import React from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';

import { Button, MenuItem } from 'core/components';

const CreateSuppressionForTarget = ({
  field,
  values,
  comment,
  asMenuItem,
  hideText,
  history,
  location,
  $auth,
  $suppressions,
  $metrics,
  ...buttonProps
}) => {
  const ids = values.filter((value) => value !== undefined && value !== null).map(String);

  if (ids.length === 0 || !$auth.hasRbacPermissions(['alerting.suppressions::create'])) {
    return null;
  }

  const handleClick = () =>
    history.push('/v4/settings/suppressions/new', {
      suppressionDraft: $suppressions.buildContextFilterDraft({ field, values: ids, comment }, $metrics),
      returnLocation: location
    });

  if (asMenuItem) {
    return <MenuItem icon="pause" text="Create Suppression" onClick={handleClick} />;
  }

  return (
    <Button
      icon="pause"
      text={hideText ? undefined : 'Create Suppression'}
      title={hideText ? 'Create Suppression' : undefined}
      onClick={handleClick}
      {...buttonProps}
    />
  );
};

export default withRouter(inject('$auth', '$suppressions', '$metrics')(observer(CreateSuppressionForTarget)));
